module.exports = __webpack_public_path__ + "img/undraw-reassign.4671ed2e.svg";